<div *ngIf="selectedPOS && !connected">
    <div class="info">
        <div class="POS-logo"
             [ngStyle]="{'background-image': 'url(../../../../../../assets/pos/shopify_white.png)'}"></div>
        <!-- <div class="pos-title">Shopify</div> -->
        <div class="write-up">Shopify is a commerce platform that allows anyone to set up an online store and sell their
            products. ... Shopify is now the leading commerce platform designed for businesses of all sizes. Whether you
            sell
            online, on social media, in store, or out of the trunk of your car, Shopify has you covered.
        </div>
    </div>
</div>

<div *ngIf="!busy && !connected">
    <div class="row margin-top-8">
        <div class="col-md-4 label">
            {{'onboarding.enter_shopify_shop_name' | translate}}:
        </div>
        <div class="col-md-8">
            <div class="p-inputgroup">
                <input type="text" pInputText [(ngModel)]="shopName" placeholder="xxxxxxx.myshopify.com"/>
            </div>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-4 label">
        </div>
        <div class="col-md-8">
            <button type="button" (click)="getAuthURL()" class="btn btn-primary"
                    [disabled]="shopName === null || shopName.length === 0">Connect to Shopify
            </button>
        </div>
    </div>

</div>

<div *ngIf="busy" style="display: block; margin-left: auto;text-align: right;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4" fill="transparent"
                       animationDuration=".5s">
    </p-progressSpinner>
</div>
<div class="wizard-message box center margin-top-0" *ngIf="connected && message">
    <div [innerHTML]="message"></div>
</div>
<div class="wizard-message fail center margin-top-16" *ngIf="message && !connected">
    <div [innerHTML]="message"></div>
</div>
<div *ngIf="connected" class="margin-top-16">
    <div style="font-size: 13px; text-align: center;">{{'onboarding.messages.pos_connected_info' | translate}}</div>
    <app-shopify-defaults [partner]="partner" (status)="configurationUpdate($event)"></app-shopify-defaults>
</div>
<div *ngIf="partner.VerificationID" class="margin-top-32">
    <div class="row">
        <div class="col-md-6">
            <button pButton (click)="skipToHubtiger()" class="p-button alternate full-width"
                    label="{{ 'onboarding.button.skip_to_hubtiger' | translate}}" *ngIf="!configurationSaved"></button>
        </div>
        <div class="col-md-6">
            <button pButton type="button" (click)="done()" class="p-button primary full-width"
                    [disabled]="!configurationSaved" label="{{ 'onboarding.button.done' | translate}}"></button>
        </div>
    </div>
</div>
